import { render, staticRenderFns } from "./FrontendNav.vue?vue&type=template&id=0952544f&"
import script from "./FrontendNav.vue?vue&type=script&lang=js&"
export * from "./FrontendNav.vue?vue&type=script&lang=js&"
import style0 from "./FrontendNav.vue?vue&type=style&index=0&id=0952544f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports